export default __webpack_public_path__ + "/dist/images/product-item.60eb147897edd8e33ee43179895dce4e.svg";